module.exports = __webpack_public_path__ + "img/postnl.08044c87.png";